import { type CookieStore } from '@/utilities/cookieStore';

export function getUserIdAndVariationType(cookieStore: CookieStore) {
  return {
    variationType: getVariationType(cookieStore),
    userId: getUserId(cookieStore),
  };
}

/**
 * Returns the current variation type for the visitor.
 *
 * The variation type is used for segmentation purposes, allowing features
 * such as targeting based on an assigned group.
 *
 * @returns the variation type string, or an empty string if not set or unknown.
 */
function getVariationType(cookieStore: CookieStore): string {
  const variationCookie = cookieStore.get('variationType');

  return variationCookie && variationCookie !== 'unknown' ? variationCookie : '';
}

/**
 * Returns the user ID for the current environment and country.
 *
 * The user ID is used to consistently identify a visitor across sessions
 * so that features like personalisation and customisation can be applied.
 *
 * @returns the user ID string, or `undefined` if no ID is available.
 */
function getUserId(cookieStore: CookieStore): string | undefined {
  return cookieStore.get('_ga');
}
